module.exports = __webpack_public_path__ + "images/867efe9888027fc93555996815098530a195176c03bb167bb79ce8832cd270bb.svg";